import * as React from 'react'
export function ErrorImageSVG(props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='80%'
      viewBox='0 0 500 500'
      {...props}
    >
      <defs>
        <clipPath id='prefix__a'>
          <path fill='none' d='M55.67 159h230v228h-230z' />
        </clipPath>
        <clipPath id='prefix__b'>
          <path
            d='M224.07 184.9s25.61 30.42 31 36 5.59 9.63 3.85 12.13-14.82 7.13-28.3 15.79-51.8 31-52.18 31.78-4.05-27-4.05-27l64.12-26.38-.19-1.93-20.8-38.51z'
            fill='#fff'
            stroke='#263238'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={0.75}
          />
        </clipPath>
        <clipPath id='prefix__c'>
          <path
            d='M157.76 389.39c10.46-1.76 23.86-8.95 27.85-18-3-15.69-6.79-37.79-6.79-51.31 0-22.72 6-35.62 3.27-51s-8.47-25.41-14.63-29.46c0 0-9.43 2.5-19.06 11.55s-18.1 24.61-21.4 39.44-7.7 60.46-7.7 72.4-.86 26.76-.86 26.76h34.59a26.46 26.46 0 004.73-.38z'
            fill='#fff'
            stroke='#263238'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={0.75}
          />
        </clipPath>
        <clipPath id='prefix__d'>
          <path
            d='M179.78 214.93s.58 7.51 1.16 11.17-8.47 13.9-8.47 13.9l13.09 19.83 14.83-11.55s21-1.54 22.91-3.28 1.93-20.79 1.93-20.79l5-2.89s-4.62-20-5.77-24.46l-1.16-4.42s6.74-2.32 5.2-9-11.36-10-21.18-8.48-12.32 5.2-12.32 5.2-13.87-.19-21.76 6.36-3.08 16.94-.58 20.6a57.23 57.23 0 007.12 7.81z'
            fill='#fff'
            stroke='#263238'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={0.75}
          />
        </clipPath>
        <clipPath id='prefix__e'>
          <path
            d='M194.8 224.56s-1.15-12.13-7.12-12.51-5.78 8.28-4 14.25 6 7.89 9.43 4.81'
            fill='#ffa540'
            stroke='#263238'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={0.75}
          />
        </clipPath>
        <clipPath id='prefix__f'>
          <path
            d='M173 232.65l19.26 29.27-8.86 11.36a223.78 223.78 0 00-13.28-22.34c-6.55-9.24-7.32-10.78-7.32-10.78z'
            fill='#fff'
            stroke='#263238'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={0.75}
          />
        </clipPath>
        <clipPath id='prefix__g'>
          <path
            d='M167.85 296.77s-5.59-23.3-7.9-28.5-15.4-10-21.76 1.35-.58 24.26 1.74 33.5 16.94 51 19.06 56.23 6 4 8.09 3.47 60.65-47.76 60.65-47.76l-4.62-10.39L177.67 328z'
            fill='#fff'
            stroke='#263238'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={0.75}
          />
        </clipPath>
      </defs>
      <path
        d='M429.84 253.51c-3.39-27-11.87-53.07-22-71.76-24.47-44.91-92.64-74.95-144-67.18-43.81 6.62-64.86 46.59-104.36 60.46-36.34 12.76-69.06 22.61-86.19 56.28C37 302.43 125.71 380.18 201.74 374.12c24-1.92 45.44-11.15 70.07-6.82 50 8.79 66.6 18.24 110.76.66 43.51-17.33 53.2-67.22 47.27-114.45z'
        fill='#ffa540'
      />
      <path
        d='M429.84 253.51c-3.39-27-11.87-53.07-22-71.76-24.47-44.91-92.64-74.95-144-67.18-43.81 6.62-64.86 46.59-104.36 60.46-36.34 12.76-69.06 22.61-86.19 56.28C37 302.43 125.71 380.18 201.74 374.12c24-1.92 45.44-11.15 70.07-6.82 50 8.79 66.6 18.24 110.76.66 43.51-17.33 53.2-67.22 47.27-114.45z'
        fill='#fff'
        opacity={0.8}
      />
      <path
        fill='#fff'
        stroke='#263238'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={0.75}
        d='M254.91 389.43l-42.65-95.5h103.35L443.06 378'
      />
      <path
        fill='#263238'
        stroke='#263238'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={0.75}
        d='M244.33 385.67l-32.07-85.37v-6.37l45.37 99.95-13.3-8.21z'
      />
      <path
        fill='#fff'
        stroke='#263238'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={0.75}
        d='M271.35 297.88l43.96 51.53-53.36 12.43-30.32-57.6 39.72-6.36z'
      />
      <path
        fill='#263238'
        stroke='#263238'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={0.75}
        d='M261.95 361.84v1.52l52.45-10.61.91-3.34-53.36 12.43z'
      />
      <path
        fill='#263238'
        d='M269.69 316.42l2.25 3.32 5.72-1.55-2.38-3.24-5.59 1.47zM291.34 336.73l-2.72-3.68-6.5 1.75 2.54 3.76 6.68-1.83zM265.02 309.5l1.67 2.48 5.38-1.37-1.69-2.3-5.36 1.19zM275.38 324.83l3.08 4.56 6.29-1.59-3.4-4.61-5.97 1.64zM291.67 326.97l-5.39 1.37 2.7 3.66 5.49-1.48-2.8-3.55zM279.01 330.19l2.57 3.82 6.46-1.75-2.71-3.68-6.32 1.61zM258.93 310.85l1.66 2.68 5.16-1.32-1.69-2.5-5.13 1.14zM272.47 320.53l2.38 3.51 5.92-1.64-2.53-3.43-5.77 1.56zM267.23 312.77l1.92 2.85 5.54-1.46-2.04-2.77-5.42 1.38zM255.59 319.2l-1.68-3.03-6.13 1.56 1.71 3.08 6.1-1.61zM246.78 326.53l4.21-1.13-1.95-3.52-4.14 1.09 1.88 3.56zM257.11 307.91l1.31 2.12 5.09-1.13-1.37-2.02-5.03 1.03zM253.45 315.34l-1.62-2.92-6.23 1.37 1.72 3.11 6.13-1.56zM251.06 309.14l1.24 2.24 5.18-1.14-1.33-2.14-5.09 1.04zM242.35 318.17l4.06-1.04-1.74-3.13-4.05.89 1.73 3.28zM243.84 310.62l1.3 2.34 6.23-1.37-1.25-2.26-6.28 1.29zM263.41 318.08l2.1 3.39 5.5-1.48-2.25-3.32-5.35 1.41zM277.53 329.63l-3.07-4.54-5.73 1.58 2.78 4.49 6.02-1.53zM252.76 312.21l1.6 2.9 5.3-1.35-1.67-2.7-5.23 1.15zM253.96 330.74l-4.32 1.19 2.24 4.23 4.45-1.13-2.37-4.29zM266.01 322.28l2.22 3.58 5.69-1.56-2.37-3.52-5.54 1.5zM261.99 317.52l-1.83-2.95-5.34 1.36 1.68 3.04 5.49-1.45zM272.02 348.87l-6.11 1.56 2.18 3.93 6.13-1.51-2.2-3.98zM262.56 305.87l5.23-1.07-2.81-3.82-5.15.85 2.73 4.04zM249.66 308.5l-2.53-4.57-6.41 1.06 2.66 4.8 6.28-1.29zM257.98 323.51l-1.93-3.49-6.1 1.61 1.95 3.52 6.08-1.64zM273.55 336.18l-2.46-3.97-6.36 1.62 2.28 4.12 6.54-1.77zM270.59 331.4l-2.78-4.48-5.99 1.65 2.45 4.43 6.32-1.6zM280.65 334.26l-2.58-3.83-6.06 1.54 2.46 3.96 6.18-1.67zM264.59 321.72l-2.1-3.4-5.54 1.47 1.93 3.47 5.71-1.54zM261.09 314.34l1.82 2.93 5.31-1.4-1.93-2.86-5.2 1.33zM267.31 326.12l-2.22-3.59-5.76 1.55 2.04 3.68 5.94-1.64zM283.74 338.82l-2.55-3.76-6.22 1.68 2.37 3.83 6.4-1.75zM279.63 345.99l-2.71-4.37-6.84 1.88 2.4 4.31 7.15-1.82zM259.13 340.08l-2.34-4.23-4.47 1.14 2.28 4.32 4.53-1.23zM251.45 326.22l-4.23 1.14 1.99 3.75 4.29-1.18-2.05-3.71zM271.56 348.05l-2.38-4.31-6.06 1.66 2.33 4.2 6.11-1.55zM260.46 328l-2.03-3.67-6.08 1.64 2.06 3.71 6.05-1.68zM263.11 306.68l1.36 2.01 5.32-1.18-1.41-1.91-5.27 1.08zM240.18 314.06l4.03-.89-1.3-2.36-4.02.82 1.29 2.43zM256.59 307.08l5-1.02-2.75-4.07-4.9.81 2.65 4.28zM250.6 308.31l5.05-1.03-2.68-4.32-4.89.81 2.52 4.54zM248.59 321.06l-1.72-3.1-4.08 1.04 1.67 3.14 4.13-1.08zM268.77 304.6l4.52-.93-2.84-3.59-4.47.73 2.79 3.79zM242.44 309.98l-2.68-4.84-3.96.66 2.65 4.99 3.99-.81zM265 350.66l-4.8 1.22 2.08 3.92 4.9-1.21-2.18-3.93zM287.81 344.84l-6.76 1.72 2.47 3.99 6.98-1.73-2.69-3.98zM280.13 346.8l-7.2 1.83 2.21 3.99 7.45-1.84-2.46-3.98zM295.81 342.8l-7.06 1.8 2.69 3.99 7.31-1.81-2.94-3.98zM302.76 341.03l-6 1.53 2.95 3.99 6.2-1.54-3.15-3.98zM262.22 345.65l-4.65 1.27 2.19 4.14 4.78-1.22-2.32-4.19zM276.42 340.82l-2.37-3.83-6.58 1.78 2.16 3.91 6.79-1.86zM287.27 344.04l-3-4.43-6.43 1.76 2.71 4.38 6.72-1.71zM268.73 342.92l-2.17-3.91-6.07 1.65 2.18 3.92 6.06-1.66zM257.14 346.1l4.63-1.27-2.18-3.93-4.55 1.23 2.1 3.97zM263.36 333.24l-2.44-4.42-6.06 1.67 2.38 4.3 6.12-1.55zM295.23 342.01l-3.31-4.49-6.72 1.84 3.01 4.44 7.02-1.79zM266.11 338.19l-2.29-4.13-6.12 1.56 2.34 4.22 6.07-1.65zM282.29 322.93l3.41 4.62 5.35-1.36-3.68-4.66-5.08 1.4zM275.64 313.91l4.74-1.25-2.13-2.69-4.64 1.18 2.03 2.76zM271.36 308.1l1.66 2.26 4.62-1.17-1.67-2.11-4.61 1.02zM302.14 340.25l-3.58-4.55-5.7 1.56 3.32 4.51 5.96-1.52zM276.22 314.7l2.39 3.23 4.88-1.32-2.5-3.17-4.77 1.26zM289.56 332.79l2.72 3.69 5.67-1.55-2.87-3.63-5.52 1.49zM270.76 307.3l4.59-1.01-1.43-1.82-4.55.93 1.39 1.9zM281.71 322.15l5.05-1.4-2.65-3.36-4.92 1.33 2.52 3.43z'
      />
      <path
        d='M322.28 303.64v8.18a16 16 0 01-2.73 2.12c-1.51.91-13.94 3-13.94 3l15.76 17.29s14.45-1.58 18.5-2.73c4.24-1.22 3.33-16.68 3.33-16.68z'
        fill='#fff'
        stroke='#263238'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={0.75}
      />
      <path
        d='M322.28 303.64v8.18s-.22.22-.58.54l18.43 19.06c3.94-1.77 3.07-16.57 3.07-16.57z'
        fill='#263238'
        stroke='#263238'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={0.75}
      />
      <path
        fill='#fff'
        stroke='#263238'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={0.75}
        d='M294.39 199.04v86.71l66.09 52.14v-134l-66.09-4.85z'
      />
      <path
        fill='#ffa540'
        stroke='#263238'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={0.75}
        d='M298.94 203.59v73.06l55.48 34.26V208.44l-55.48-4.85z'
      />
      <path
        fill='#263238'
        stroke='#263238'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={0.75}
        d='M360.48 203.89h6.67v134.03h-6.67z'
      />
      <path
        fill='#fff'
        stroke='#263238'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={0.75}
        d='M302.58 208.14l.3 65.18 46.38 26.37v-80.71l-31.83-4.82-2.12-4.51-12.73-1.51z'
      />
      <path
        fill='#ffa540'
        stroke='#263238'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={0.75}
        d='M305.61 216.02v55.48l40.93 21.83V223.3l-40.93-7.28z'
      />
      <ellipse
        cx={324.72}
        cy={255.73}
        rx={11.03}
        ry={15.2}
        transform='rotate(-18.56 324.813 255.777)'
        fill='#263238'
      />
      <path
        d='M325.92 256.67l3.89-4.31a2.21 2.21 0 00-.07-2.59c-.58-.83-1.49-1-2-.41l-3.74 4.15-3.75-6c-.54-.87-1.45-1.14-2-.6a2.11 2.11 0 00-.08 2.55l3.89 6.25-3.96 4.29a2.2 2.2 0 00.08 2.59 1.68 1.68 0 001 .73 1 1 0 001-.32l3.75-4.15 3.74 6a1.79 1.79 0 001.06.84 1 1 0 001-.24 2.12 2.12 0 00.07-2.55z'
        fill='#fff'
      />
      <path
        fill='none'
        stroke='#263238'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={0.75}
        d='M312.88 234.82l22.92 6.73M311.97 228.45l29.71 8.29'
      />
      <path
        d='M332.45 371.31s-14.49 1.34-19.85 5.63-1.34 6.44 3.75 7.78 27.9-.81 30.85-3.76 0-10.19-14.75-9.65z'
        fill='#fff'
        stroke='#263238'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={0.75}
      />
      <path
        d='M347.2 381a3.46 3.46 0 001-2.12c-6.49-.32-15 1.56-22.73 4a81.06 81.06 0 01-7.94 2.09c6.74.81 26.91-1.25 29.67-3.97z'
        fill='#263238'
        stroke='#263238'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={0.75}
      />
      <path
        fill='none'
        stroke='#263238'
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M281.08 212.16l10.59 5.51M275 209l3.15 1.64M283.41 239.92l3.59.41M269.67 238.33l9.68 1.12M285.67 265.67l-12 3.33'
      />
      <g>
        <path
          d='M270.18 119a28.7 28.7 0 1028.7 28.7 28.7 28.7 0 00-28.7-28.7zm0 51.76a23.06 23.06 0 1123.07-23.06 23.05 23.05 0 01-23.07 23.09z'
          fill='#263238'
        />
        <path
          d='M272.23 147.73a2.05 2.05 0 11-2.05-2 2.05 2.05 0 012.05 2z'
          fill='#263238'
        />
        <path
          fill='none'
          stroke='#263238'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M263.31 158.14l6.87-10.41 11.61 9.61'
        />
      </g>
      <g>
        <path
          fill='#ffa540'
          d='M117.88 169.73l-3.45-9.43 1.84 2.07v-3.22l3.91 5.98-3.45-21.39 4.6 11.73.46-10.35.69 3.45.92-11.73 1.61 17.94 2.3-6.21-.46 8.05 6.21-18.4-2.99 23 4.37-3.22-2.53 4.14 3.22-2.3-3.67 10.58-13.35.23'
        />
        <path
          fill='#263238'
          stroke='#263238'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M132.64 192.96h-14.38l-3.88-24.92h22.13l-3.87 24.92z'
        />
        <path
          fill='#fff'
          stroke='#263238'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M99.42 192.79h72.59V385.9H99.42z'
        />
        <path
          fill='none'
          stroke='#263238'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M103.64 199.13h63.43v46.51h-63.43z'
        />
        <path fill='#263238' d='M122.67 218.16h25.37v8.46h-25.37z' />
        <path
          fill='none'
          stroke='#263238'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M103.64 253.4h63.43v46.51h-63.43z'
        />
        <path fill='#263238' d='M122.67 272.43h25.37v8.46h-25.37z' />
        <path
          fill='none'
          stroke='#263238'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M103.64 307.66h63.43v46.51h-63.43z'
        />
        <path fill='#263238' d='M122.67 326.69h25.37v8.46h-25.37z' />
      </g>
      <g>
        <g clipPath='url(#prefix__a)'>
          <path
            d='M179.79 374.88s36.38-16.07 55.94-17.28L250 389.13H142.22z'
            fill='#263238'
            stroke='#263238'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={0.75}
          />
          <path
            d='M224.07 184.9s25.61 30.42 31 36 5.59 9.63 3.85 12.13-14.82 7.13-28.3 15.79-51.8 31-52.18 31.78-4.05-27-4.05-27l64.12-26.38-.19-1.93-20.8-38.51z'
            fill='#fff'
          />
          <g clipPath='url(#prefix__b)'>
            <path
              d='M248.72 229.8L219 186.4l-1.43.42 20.8 38.51.19 1.93-64.12 26.38s.07.48.17 1.29l4.18 9.59z'
              fill='#ffa540'
            />
            <path
              d='M248.72 229.8L219 186.4l-1.43.42 20.8 38.51.19 1.93-64.12 26.38s.07.48.17 1.29l4.18 9.59z'
              fill='#fff'
              opacity={0.5}
            />
          </g>
          <path
            d='M224.07 184.9s25.61 30.42 31 36 5.59 9.63 3.85 12.13-14.82 7.13-28.3 15.79-51.8 31-52.18 31.78-4.05-27-4.05-27l64.12-26.38-.19-1.93-20.8-38.51z'
            fill='none'
            stroke='#263238'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={0.75}
          />
          <path
            d='M203.66 171.61s-3.08-2.7-4.62 0-1.73 7.12-.77 7.51 4.81-.19 5.39-1.35 0-6.16 0-6.16z'
            fill='#fff'
            stroke='#263238'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={0.75}
          />
          <path
            d='M209.05 170.26s-3.27-3.46-5.39-2.12-1.54 8.67-.77 9.25 5.39-1 6-1.93.16-5.2.16-5.2z'
            fill='#fff'
            stroke='#263238'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={0.75}
          />
          <path
            d='M216.37 170.45s-2.89-4-5.58-4-4.63 9.63-3.66 10.4 7.31-.19 7.7-.77a52.44 52.44 0 001.54-5.63z'
            fill='#fff'
            stroke='#263238'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={0.75}
          />
          <path
            d='M222 177c0-1.15-.57-11.17-4-10.59s-7.12 8.67-6.93 10S222 177 222 177zM238.51 227.26s9.82 3.66 13.48 3.46'
            fill='#fff'
            stroke='#263238'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={0.75}
          />
          <path
            d='M157.76 389.39c10.46-1.76 23.86-8.95 27.85-18-3-15.69-6.79-37.79-6.79-51.31 0-22.72 6-35.62 3.27-51s-8.47-25.41-14.63-29.46c0 0-9.43 2.5-19.06 11.55s-18.1 24.61-21.4 39.44-7.7 60.46-7.7 72.4-.86 26.76-.86 26.76h34.59a26.46 26.46 0 004.73-.38z'
            fill='#fff'
          />
          <g clipPath='url(#prefix__c)'>
            <path
              d='M185.61 371.38c-5.86 5-32.25 14.71-36.1 15.57s-1.71-7.28 4.28-15.41-7.28 3-9.42 3.85.86-15.84.86-24 7.71-77.48 7.71-77.48l14.55-26.55 5-3a21.48 21.48 0 00-5-4.79s-9.43 2.5-19.06 11.55-18.13 24.66-21.43 39.49-7.7 60.46-7.7 72.4-.86 26.76-.86 26.76h34.59a26.46 26.46 0 004.71-.42c10.48-1.72 23.88-8.91 27.87-17.97z'
              fill='#ffa540'
            />
            <path
              d='M185.61 371.38c-5.86 5-32.25 14.71-36.1 15.57s-1.71-7.28 4.28-15.41-7.28 3-9.42 3.85.86-15.84.86-24 7.71-77.48 7.71-77.48l14.55-26.55 5-3a21.48 21.48 0 00-5-4.79s-9.43 2.5-19.06 11.55-18.13 24.66-21.43 39.49-7.7 60.46-7.7 72.4-.86 26.76-.86 26.76h34.59a26.46 26.46 0 004.71-.42c10.48-1.72 23.88-8.91 27.87-17.97z'
              fill='#fff'
              opacity={0.5}
            />
          </g>
          <path
            d='M157.76 389.39c10.46-1.76 23.86-8.95 27.85-18-3-15.69-6.79-37.79-6.79-51.31 0-22.72 6-35.62 3.27-51s-8.47-25.41-14.63-29.46c0 0-9.43 2.5-19.06 11.55s-18.1 24.61-21.4 39.44-7.7 60.46-7.7 72.4-.86 26.76-.86 26.76h34.59a26.46 26.46 0 004.73-.38z'
            fill='none'
            stroke='#263238'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={0.75}
          />
          <path
            d='M166.9 243.16l16.54 30.12.89 16.52s4.61-11.78 2.56-19.47-19.99-27.17-19.99-27.17z'
            fill='#263238'
            stroke='#263238'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={0.75}
          />
          <path
            fill='#263238'
            stroke='#263238'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={0.75}
            d='M184.32 289.81l-4.61 69.71 5.13 14.35 3.59-28.71-3.08-57.41-1.03 2.06z'
          />
          <path
            d='M179.78 214.93s.58 7.51 1.16 11.17-8.47 13.9-8.47 13.9l13.09 19.83 14.83-11.55s21-1.54 22.91-3.28 1.93-20.79 1.93-20.79l5-2.89s-4.62-20-5.77-24.46l-1.16-4.42s6.74-2.32 5.2-9-11.36-10-21.18-8.48-12.32 5.2-12.32 5.2-13.87-.19-21.76 6.36-3.08 16.94-.58 20.6a57.23 57.23 0 007.12 7.81z'
            fill='#fff'
          />
          <g clipPath='url(#prefix__d)'>
            <path
              d='M203 241.83c-3.85-4.71 0-22.69 3-31.68s-4.28-12.84-4.28-12.84l21.86-3.77-.3-1.13a9.74 9.74 0 003.83-2.71l1.18-6.95c-2-6.32-11.47-9.36-21-7.87-9.82 1.54-12.32 5.2-12.32 5.2s-13.87-.19-21.76 6.36-3.08 16.94-.58 20.6a57.23 57.23 0 007.12 7.89s.58 7.51 1.16 11.17-8.44 13.9-8.44 13.9l13.09 19.83 14.83-11.55s16-1.18 21.36-2.63l1.55-.65s-16.43 1.54-20.3-3.17z'
              fill='#ffa540'
            />
            <path
              d='M203 241.83c-3.85-4.71 0-22.69 3-31.68s-4.28-12.84-4.28-12.84l21.86-3.77-.3-1.13a9.74 9.74 0 003.83-2.71l1.18-6.95c-2-6.32-11.47-9.36-21-7.87-9.82 1.54-12.32 5.2-12.32 5.2s-13.87-.19-21.76 6.36-3.08 16.94-.58 20.6a57.23 57.23 0 007.12 7.89s.58 7.51 1.16 11.17-8.44 13.9-8.44 13.9l13.09 19.83 14.83-11.55s16-1.18 21.36-2.63l1.55-.65s-16.43 1.54-20.3-3.17z'
              fill='#fff'
              opacity={0.5}
            />
            <path
              d='M214.25 206.08v-.77c0-1.49.25-4.71 2.74-5.59 3.27-1.15 6 1.93 6 1.93l.19 3.08a4.25 4.25 0 00-4-1.54 9 9 0 00-4.93 2.89zM219.84 212.24c0 1.59-.44 2.89-1 2.89s-1-1.3-1-2.89.43-2.89 1-2.89 1 1.29 1 2.89zM213.77 232.41c-1.07 1.11-2.5 1.47-3.19.81s-.38-2.11.69-3.22 2.49-1.47 3.18-.81.39 2.11-.68 3.22z'
              fill='#263238'
            />
          </g>
          <path
            d='M179.78 214.93s.58 7.51 1.16 11.17-8.47 13.9-8.47 13.9l13.09 19.83 14.83-11.55s21-1.54 22.91-3.28 1.93-20.79 1.93-20.79l5-2.89s-4.62-20-5.77-24.46l-1.16-4.42s6.74-2.32 5.2-9-11.36-10-21.18-8.48-12.32 5.2-12.32 5.2-13.87-.19-21.76 6.36-3.08 16.94-.58 20.6a57.23 57.23 0 007.12 7.81z'
            fill='none'
            stroke='#263238'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={0.75}
          />
          <path
            d='M198.27 196.06c3.47-2.31 25-3.65 25-3.65s6.74-2.32 5.2-9-11.36-10-21.18-8.48-12.32 5.2-12.32 5.2-13.87-.19-21.76 6.36-3.08 16.94-.58 20.6a57.23 57.23 0 007.12 7.89s.32 4.12.72 7.75l6 1.69 6.55-3.47 6.55-1.54s-4.82-3.66-2.12-7.12 7.7-4.62 7.89-7.32-10.54-6.6-7.07-8.91z'
            fill='#263238'
            stroke='#263238'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={0.75}
          />
          <path
            d='M219.29 184.87s-2.26-4.14 1.88-3.39 4.14 7.91.75 9.41-21.83-1.88-32 1.13-17.31 11.29-17.31 11.29M178.26 209.71s7.91-6.77 14.3-7.9 9.79-1.13 2.64 3-2.26 3.38 2.26 1.88'
            fill='none'
            stroke='#fff'
            strokeLinecap='round'
            strokeMiterlimit={10}
          />
          <path
            d='M194.8 224.56s-1.15-12.13-7.12-12.51-5.78 8.28-4 14.25 6 7.89 9.43 4.81'
            fill='#ffa540'
          />
          <g clipPath='url(#prefix__e)'>
            <path
              d='M194.8 224.56s-1.15-12.13-7.12-12.51-5.78 8.28-4 14.25 6 7.89 9.43 4.81'
              fill='#fff'
              stroke='#263238'
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={0.75}
              opacity={0.5}
            />
          </g>
          <path
            d='M194.8 224.56s-1.15-12.13-7.12-12.51-5.78 8.28-4 14.25 6 7.89 9.43 4.81'
            fill='none'
            stroke='#263238'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={0.75}
          />
          <path
            d='M173 232.65l19.26 29.27-8.86 11.36a223.78 223.78 0 00-13.28-22.34c-6.55-9.24-7.32-10.78-7.32-10.78z'
            fill='#fff'
          />
          <g clipPath='url(#prefix__f)'>
            <path
              d='M173 232.65l-10.2 7.51s.57 1.13 4.77 7.16l10.78-6.54z'
              fill='#ffa540'
            />
            <path
              d='M173 232.65l-10.2 7.51s.57 1.13 4.77 7.16l10.78-6.54z'
              fill='#fff'
              opacity={0.5}
            />
          </g>
          <path
            d='M173 232.65l19.26 29.27-8.86 11.36a223.78 223.78 0 00-13.28-22.34c-6.55-9.24-7.32-10.78-7.32-10.78z'
            fill='none'
            stroke='#263238'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={0.75}
          />
          <path
            d='M222.53 305.44s3.08-6.36 3.66-10.4.77-6.36 3.08-8.28 9.82-9.63 11-12.52 1.92-.19 2.5 2.12.38 4.43-1.54 5.78a21.23 21.23 0 00-3.66 3.46l1.73 1.35s24.07-9.05 26.58-10 4.81-.2 5 1.73-.57 2.12-1.73 2.7-13.86 5-15.6 5.77l-1.73.77 1.35 1.35s6.93-.19 10.4-.38 8.66-.77 9.43.38a2.4 2.4 0 01-.58 3.27 3.72 3.72 0 01-3.08 1c-1.73 0-16.56 1.15-16.56 1.15l.39 2.12s15.79 2.5 16.36 3.27.58 1.16 0 2.31-1 1.16-2.5 1.16-14-1.93-14-1.93 6.16 3.47 6.93 4.05 3.46 1 2.69 2.31-1.15 1.73-2.31 1.54-9.43-3.85-9.43-3.85-8.28 1.15-11 1.35a37.73 37.73 0 01-6-.2l-7.7 5z'
            fill='#fff'
            stroke='#263238'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={0.75}
          />
          <path
            d='M167.85 296.77s-5.59-23.3-7.9-28.5-15.4-10-21.76 1.35-.58 24.26 1.74 33.5 16.94 51 19.06 56.23 6 4 8.09 3.47 60.65-47.76 60.65-47.76l-4.62-10.39L177.67 328z'
            fill='#fff'
          />
          <g clipPath='url(#prefix__g)'>
            <path
              d='M166.21 348a139.72 139.72 0 015.13-13.27c2.14-4.28-10.27 9.85-12.84 2.14s-18.83-46.23-15.84-59.07a24.35 24.35 0 019.78-14.74c-4.77-1.13-10.61.07-14.25 6.57-6.35 11.36-.58 24.26 1.74 33.5s16.94 51 19.06 56.23 6 4 8.09 3.47c1.54-.42 33-25.55 50-39.18z'
              fill='#ffa540'
            />
            <path
              d='M166.21 348a139.72 139.72 0 015.13-13.27c2.14-4.28-10.27 9.85-12.84 2.14s-18.83-46.23-15.84-59.07a24.35 24.35 0 019.78-14.74c-4.77-1.13-10.61.07-14.25 6.57-6.35 11.36-.58 24.26 1.74 33.5s16.94 51 19.06 56.23 6 4 8.09 3.47c1.54-.42 33-25.55 50-39.18z'
              fill='#fff'
              opacity={0.5}
            />
          </g>
          <path
            d='M167.85 296.77s-5.59-23.3-7.9-28.5-15.4-10-21.76 1.35-.58 24.26 1.74 33.5 16.94 51 19.06 56.23 6 4 8.09 3.47 60.65-47.76 60.65-47.76l-4.62-10.39L177.67 328z'
            fill='none'
            stroke='#263238'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={0.75}
          />
          <path
            fill='#fff'
            stroke='#263238'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={0.75}
            d='M216.37 308.52l5.2 10.59M94.22 255.39l-26.6 18.45s13.11 13.86 11.76 50.22c-1 27.77 2.67 59.3 8 65.71h28.32s-9.79-54-9.09-84.94c.55-23.51-6.51-39.83-12.39-49.44z'
          />
          <path
            d='M97.42 255.39l-26.6 18.45s13.11 13.86 11.75 50.22c-1 27.77 2.67 59.3 8 65.71h28.33s-9.78-54-9.08-84.94c.53-23.51-6.53-39.83-12.4-49.44z'
            fill='#263238'
            stroke='#263238'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={0.75}
          />
          <path
            fill='#fff'
            stroke='#263238'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={0.75}
            d='M94.22 255.39h3.2l-26.6 18.45h-3.19l26.59-18.45z'
          />
        </g>
      </g>
    </svg>
  )
}
